import { Helmet } from 'react-helmet';

import OurStory from '../components/About/OurStory';
import Record from '../components/About/Record';
import FindOutMore from '../components/About/FindOutMore';
import Quality from '../components/About/Quality';
import Standards from '../components/About/Standards';

function About() {
  return (
    <div className="about__container full-horizon">
      <Helmet>
        <meta charSet="utf-8" />
        <title>라이프스팬 - 회사소개</title>
      </Helmet>
      <OurStory />
      <Record />
      <FindOutMore />
      <Quality />
      <Standards />
    </div>
  );
}

export default About;
